import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import OverviewRegularAi from './overview-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <OverviewRegularAi {...validProps} />;
}
SvgComponent.iconName = 'overviewRegularAi';

export const OverviewRegularAiIcon = svgIconWrapper(SvgComponent);
